export const AUTHENTICATE = 'authenticate';
export const DEAUTHENTICATE = 'deauthenticate';
export const GET_USER = 'get_user';
export const CLEAR_USER = 'clear_user';
export const DEFAULT = 'default';



// WEBPACK FOOTER //
// ./src/lib/redux/types.js